import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AddressSearchResults } from '../../Models/Domains/Address/AddressSearchResults';
import { CountryCode } from '../../Constants/Enums/Domain/CountryCode';

declare var IS_RUNNING_IN_APP_POOL;

export class FindAddressesClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(term: string, countryCode: CountryCode, lastId: string): Promise<AddressSearchResults, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Address/FindAddresses/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { term: term, countryCode: countryCode, lastId: lastId }

    return AjaxWrapper.get<AddressSearchResults, any>(url, data);
  }
}

